/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_RegenerateInputs */

const cs_property_legal_regenerate = /** @type {(inputs: Property_Legal_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přegenerovat`)
};

const en_property_legal_regenerate = /** @type {(inputs: Property_Legal_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerate`)
};

/**
* | output |
* | --- |
* | "Regenerate" |
*
* @param {Property_Legal_RegenerateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_regenerate = /** @type {((inputs?: Property_Legal_RegenerateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_RegenerateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_regenerate(inputs)
	return cs_property_legal_regenerate(inputs)
});